import { render } from "./ZoneDetail.vue?vue&type=template&id=7073db46&scoped=true"
import script from "./ZoneDetail.vue?vue&type=script&lang=js"
export * from "./ZoneDetail.vue?vue&type=script&lang=js"

import "./ZoneDetail.vue?vue&type=style&index=0&id=7073db46&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7073db46"]])

export default __exports__